<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash>
</sub-header>
<p-scrollPanel [style]="{width: '100%', height: '90vh'}" styleClass="custombar1 ">
  <div class="container-fluid">
    <!-- Mensaje Paso 1-->
    <div class="alert" [ngClass]="'alert-info'" role="alert" *ngIf="currentStep == 1">
      <div class="row">
        <div class="col-12">
          <span><i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i>
            {{'Signature.Massive.ProcessStatus.Pending' | translate}} </span>
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="col-12 text-right">
          <span
            [innerHTML]="translateService.instant('Signature.Massive.TaskSelection', {selected: task2Sign.length, total: signatureTasks.length} )"></span>
        </div>
      </div>
    </div>
    <!-- Mensaje Paso 2-->
    <div class="alert" [ngClass]="(errorTasks || processStatus === ProcessStatus.ABORTED || processStatus === ProcessStatus.SELECT_CERTIFICATE_ERROR) ?
                'alert-warning':
                (processStatus === ProcessStatus.FINISHED) ? 'alert-success' : 'alert-info'" role="alert"
      *ngIf="currentStep == 2">
      <div class="row">
        <div class="col-12">
          <span><i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{ getProcessMessage() }} </span>
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="col-6">
          <span>{{'Signature.Massive.Tasks.Signed' | translate}} </span>{{signedTasks}}
        </div>
        <div class="col-6" *ngIf="errorTasks">
          <span>{{'Signature.Massive.Tasks.Error' | translate}} </span>{{errorTasks}}
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="col-12">
          <p-progressBar [value]="progressPercentage"></p-progressBar>
        </div>
      </div>
    </div>
    <p-overlayPanel #signatureMessge>
      <div class="alert alert-danger" role="alert"> {{signatureMessage}} </div>
    </p-overlayPanel>
    <!-- LISTA DE TAREAS -->
    <div class="row">
      <div class="col-12">
        <ng-container *ngTemplateOutlet="signatureTasksTemplate"></ng-container>
      </div>
    </div>
  </div>
</p-scrollPanel>
<!-- LISTADO DE TAREAS DE FIRMA-->
<ng-template #signatureTasksTemplate>
  <p-table [value]="tableTasks" [paginator]="false" [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 60, 100]"
    class="footer-over-pagination" sortField="arrivalDate" sortOrder="-1" [(selection)]="this.task2Sign"
    selectionMode="multiple" [scrollable]="false" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th class="col-icon text-center">
          <p-tableHeaderCheckbox *ngIf="currentStep == 1"></p-tableHeaderCheckbox>
        </th>
        <th style="width:75%"><span class="d-none d-md-table-cell " [pSortableColumn]="'description'">{{
            'PendingTasks.description' | translate }}</span>
          <span class="d-md-none">{{ 'Seleccionar todas' | translate }}</span>
        </th>
        <th class="d-none d-md-table-cell  text-center" style="width:110px" [pSortableColumn]="'arrivalDate'"> {{
          'PendingTasks.arrival' | translate }} </th>
        <th class="d-none d-md-table-cell  text-center" style="width:110px" [pSortableColumn]="'expirationDate'"> {{
          'PendingTasks.endDate' | translate }} </th>
        <!-- Columna acceso tarea-->
        <td class="col-icon text-center" *ngIf="currentStep == 1">
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-task>
      <tr (mouseover)="(currentStep == 2) ? showSignatureMessage(task, $event, signatureMessge) : undefined"
        (mouseout)="(currentStep == 2) ? signatureMessge.hide() :undefined">
        <td class="col-icon text-center">
          <p-tableCheckbox *ngIf="currentStep == 1" [value]="task"></p-tableCheckbox>
          <span *ngIf="currentStep == 2" class="d-inline-block">
            <a [class]="getStatusIcon(task)"></a>
          </span>
        </td>
        <!-- COLUMNA Descripcion -->
        <td>
          <!--span class="p-column-title">{{ 'PendingTasks.description' | translate }}</span-->
          <!-- 1. DESCRIPCION DE LA TAREA CON ENLACE DE PAERTURA SI LA TAREA ESTA ACTIVA -->
          <div class="taskName {{this.userService.hasInbox(task.inbox.identifier)?' text-primary':''}}"> {{
            task?.description }} <span
              *ngIf="this.userPrefs && this.userPrefs.tasksViewPrefs && this.userPrefs.tasksViewPrefs.showProfile && task.profile"
              class="badge badge-light border border-secondary ml-2 pt-0 pb-0"><small> {{ getTaskProfile(task) }}
              </small></span>
          </div>
          <!-- 2. DATOS DEL EXPEDIENTE Y ESTRUCTURA DE DIVISIONES -->
          <div class="taskDetailInfo">
            <divisionDetail class="taskDossier" [division]="task.division" [showDivisionInfo]="true" [infoLink]="false">
            </divisionDetail>
          </div>
          <!-- 3. SI LA TAREA ESTA BLOQUEADA DATOS DEL USUARIO QUE TIENE LA TAREA -->
          <div class="taskDetailInfo" *ngIf="task?.status === 'LOCKED' && task?.lockedBy">
            <span>
              <i class="fa fa-lock text-danger" aria-hidden="true"></i> {{ 'Tasks.lockedBy' | translate }}: {{
              userService.calculateUserFullName(task?.lockedBy) }} </span>
          </div>
          <!-- 4. EN MOVIL FECHAS DE LLEGADA Y VENCIMIENTO -->
          <div class="d-md-none">
            <div class="taskDetailInfo">
              <b>{{ 'PendingTasks.arrival' | translate }}:</b> {{ task.arrivalDate | date: 'dd/MM/y HH:mm' }}
            </div>
            <div class="taskDetailInfo" *ngIf="task.expirationDate">
              <b>{{ 'PendingTasks.endDate' | translate }}:</b>
              <span> {{ task.expirationDate | date: 'dd/MM/y HH:mm' }} </span>
            </div>
          </div>
        </td>
        <!-- COLUMNA fecha llegada -->
        <td class="d-none d-md-table-cell">
          <!--span class="p-column-title">{{ 'PendingTasks.arrival' | translate }}</span--> {{ task.arrivalDate | date:
          'dd/MM/y HH:mm' }}
        </td>
        <!-- COLUMNA fecha expiracion -->
        <td class="d-none d-md-table-cell">
          <!--span class="p-column-title">{{ 'PendingTasks.endDate' | translate }}</span-->
          <div *ngIf="task.expirationDate"> {{ task.expirationDate | date: 'dd/MM/y HH:mm' }} </div>
          <div *ngIf="!task.expirationDate" class=""> - </div>
        </td>
        <!-- Columna acceso a ver documentos de la tarea-->
        <td *ngIf="currentStep == 1">
          <div class="d-flex justify-content-end">
            <div class="btn-group">
              <button class="btn btn-sm btn-primary t-action-button" (click)="viewDocument(task)"
                aria-label="{{'DocumentsAction.view' | translate}}">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="text-center">
        <td colspan="6">{{ 'General.noFilteredData' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>